import { setBuilderToolbar } from '../../../../../Template/config/components/selection/SetBuilder';

export default {
  ...setBuilderToolbar,
  enableExcludeNonNormFilters: {
    ad: true,
    norm: true
  },
  exportButtons: {
    ad: {
      data: true,
      media: true
    },
    norm: {
      data: true,
      media: true
    }
  },
  sortOptions: [
    {
      "value": -1,
      "label": "Alpha Order by Brand",
      "field": "brand",
      "selected": false
    },
    {
      "value": 100,
      "label": "Ad Effect Score",
      "selected": true,
      "dataFormat": ".,0"
    },

    {
      "value": 111,
      "label": "Branded Recall",
      "selected": false
    },
    {
      "value": 121,
      "label": "Lift to Consideration",
      "selected": false
    },
    {
      "value": 122,
      "label": "Lift to Impression",
      "selected": false
    },
    {
      "value": 123,
      "label": "Net Actions",
      "selected": false,
    },
    {
      "value": 202,
      "label": "Likeability",
      "selected": false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/app/configuration/Pfizer/config/components/selection/SetBuilder/setBuilderToolbar.js